import React from 'react';
const DefaultError = (props) => (React.createElement("div", { className: "form-errors" },
    props.formErrors.map((error, index) => (React.createElement("div", { className: "invalid", key: `formError-${index}` }, error))),
    props.fieldErrors.map((error, index) => (React.createElement("div", { className: "invalid", key: `fieldError-${index}` }, error.state.errors.map((message) => (React.createElement("div", { key: message }, message))))))));
export { DefaultError };
